// extracted by mini-css-extract-plugin
export default {"task":"Task_task__0jfxd","task__header":"Task_task__header__CmJFT"};